import { render, staticRenderFns } from "./firefightingword.vue?vue&type=template&id=2aded4a0&"
import script from "./firefightingword.vue?vue&type=script&lang=js&"
export * from "./firefightingword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports